import React, { useState, useEffect } from 'react';
import { Alert, useTheme, useMediaQuery, MenuItem, TextField } from '@mui/material';
import '../styles/commonStyle.css';
import Snackbar from '@mui/material/Snackbar';
import { RequestBookingService } from "../components/services/RequestBookingService"
import NewBookingForm2 from './NewBookingForm2';
import NewBookingForm3 from './NewBookingForm3';
import CarouselBooking from '../components/CarouselBooking';
import { AppContext } from '../components/services/AppContext'
import SelectRoute from "../components/booking/common/SelectRoute";
import SelectSourceAndDestination from "../components/booking/common/SelectSourceAndDestination";
import Cookies from 'js-cookie';
import CountryCodePicker from "../components/booking/common/CountryCodePicker";
import { getUserByPhone } from "../components/services/userService"
import { createNewEnquiry } from "../components/services/userEnquiryLogService"
import { getBookingsByPhone } from "../components/services/BookingService"

// const googleApi = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
// //const googleApi = "AIzaSyC-vagKdGDTclItg8HzxXIGw_8NlVo6NOc"
// const libraries: ("places")[] = ["places"];


interface FormValues {
  name: string;
  phone: string;
  distance: number;
  source: string;
  destination: string;
  bookingDate: string;
  bookingTime: string;
  returnRide: boolean,
  numberOfPassengers: number,
  numberOfBigBags: number,
}

const NewBookingPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  AppContext.grpLastMinuteBooking = false
  const isLoggedIn = Boolean(Cookies.get('loggedUserId'));

  const [reqBooking, setReqBooking] = useState(RequestBookingService.getRequestBooking())
  const [currentStep, setCurrentStep] = useState(0);

  const [distance, setDistance] = useState<number>(0);
  const [duration, setDuration] = useState<string | null>(null);

  const [isReturnRide, setIsReturnRide] = useState(false);
  const [route, setRoute] = useState<string>(AppContext.selectedRoute)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isPhoneError, setIsPhoneError] = useState(false)
  const [bookingDate, setBookingDate] = useState('')

  // console.log(`process.env.NODE_ENV ${JSON.stringify(process.env)}`);
  // console.log(`process.env.REACT_APP_BACKEND_URL ${process.env.REACT_APP_BACKEND_URL}`);

  const [formValues, setFormValues] = useState<FormValues>({
    name: '',
    phone: '',
    distance: 0,
    source: '',
    destination: '',
    bookingDate: '',
    bookingTime: '',
    returnRide: false,
    numberOfPassengers: 0,
    numberOfBigBags: 0
  });

  // useEffect(() => {
  //   const isLoggedIn = Boolean(Cookies.get('loggedUserId'));
  //   const storedUser = Cookies.get('user');

  //   if (isLoggedIn && storedUser) {
  //     const user = JSON.parse(storedUser);
  //     setFormValues(prev => ({
  //       ...prev,
  //       name: user.name,
  //       phone: user.phone
  //     }));
  //     AppContext.phone = ''
  //     AppContext.phone = user.phone;
  //   }
  // }, []);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value, });
  };

  const handleNext = async () => {
    const bookingDateTime = `${formValues.bookingDate}T${formValues.bookingTime?.trimLeft()}`;
    setBookingDate(bookingDateTime);
    const bookingDate = new Date(bookingDateTime);
    const now = new Date();

    if (!formValues.name) {
      setSnackbarMessage("Please enter your name.");
      setSnackbarOpen(true);
      return;
    }
    if (formValues.phone.length < 8) {
      setSnackbarMessage("Please enter your phone number.");
      setSnackbarOpen(true);
      return;
    }
    if (!RequestBookingService.getSource()) {
      setSnackbarMessage("Please select your pick up address.");
      setSnackbarOpen(true);
      return
    }
    if (!RequestBookingService.getDestination()) {
      setSnackbarMessage("Please select your drop address.");
      setSnackbarOpen(true);
      return
    }
    if (!formValues.bookingDate) {
      setSnackbarMessage("Please select booking date.");
      setSnackbarOpen(true);
      return;
    }
    if (!formValues.bookingTime) {
      setSnackbarMessage("Please select booking time");
      setSnackbarOpen(true);
      return;
    }
    if (isPhoneError) {
      setSnackbarMessage("Please enter valid phone number.");
      setSnackbarOpen(true);
      return
    }
    if (bookingDate <= now) {
      setSnackbarMessage("The selected booking time has already passed.Please select a new one!");
      setSnackbarOpen(true);
      return;
    }

    const pickUpLocation = RequestBookingService.getSource()
    const dropLocation = RequestBookingService.getDestination()

    if (pickUpLocation && dropLocation)
      await calculateDistance(pickUpLocation, dropLocation)

    if (RequestBookingService.getRequestBooking().booking.selectedCarModel === "")
      RequestBookingService.getRequestBooking().booking.selectedCarModel = "BYD E6"
    else
      RequestBookingService.getRequestBooking().booking.selectedCarModel = AppContext.selectedCar.carModel

    RequestBookingService.getRequestBooking().booking.bookingDate = bookingDateTime


    const bookings = await getBookingsByPhone(AppContext.phone)

    AppContext.isFirstRide = !bookings || bookings.length === 0;
    console.log("AppContext.isFirstRide " + AppContext.isFirstRide)
    await createUserEnquiryLog()
    await RequestBookingService.calculateFare();

    setCurrentStep(prev => prev + 1);
  };

  const createUserEnquiryLog = async () => {

    const bookingDateTime = `${formValues.bookingDate}T${formValues.bookingTime?.trimLeft()}`;
    const bookingDate = new Date(bookingDateTime).toISOString();

    const newEnquiry = {
      name: formValues.name,
      phone: AppContext.phone,
      from: RequestBookingService.getSourceFormattedAddress(),
      to: RequestBookingService.getDestinationFormattedAddress(),
      bookingDate: bookingDate,
      returnRide: RequestBookingService.getRequestBooking().booking.returnRide,
      enquiryDate: new Date().toISOString()
    }
    await createNewEnquiry(newEnquiry)

  }

  const handleBack = () => {
    setCurrentStep(prev => prev - 1);
  };

  const calculateDistance = async (origin: google.maps.places.PlaceResult, destination: google.maps.places.PlaceResult) => {
    console.log("origin=" + origin.formatted_address)
    console.log("destination= " + destination.formatted_address)

    if (!origin.geometry?.location || !destination.geometry?.location) {
      console.error("Invalid origin or destination. Make sure both have valid geometry.");
      return;
    }
    let originLat = origin.geometry.location.lat();
    let originLng = origin.geometry.location.lng();

    if (originLat === 19.0902177 && originLng === 72.86281199999999) {
      originLat = 19.0974203;
      originLng = 72.87460759999999;
    }

    const originLatLng = {
      lat: originLat,
      lng: originLng,
    };

    let destinationLat = destination.geometry.location.lat();
    let destinationLng = destination.geometry.location.lng();

    if (destinationLat === 19.0902177 && destinationLng === 72.86281199999999) {
      destinationLat = 19.0974203;
      destinationLng = 72.87460759999999;
    }
    const destinationLatLng = {
      lat: destinationLat,
      lng: destinationLng,
    };
    console.log("Origin LatLng:", originLatLng);
    console.log("Destination LatLng:", destinationLatLng);

    const directionsService = new google.maps.DirectionsService();
    const results = await directionsService.route({
      origin: originLatLng,
      destination: destinationLatLng,
      travelMode: google.maps.TravelMode.DRIVING,
      provideRouteAlternatives: true,
    });

    if (results.routes[0]) {
      const route = results.routes[0];
      //  console.log("route = " + JSON.stringify(route))
      const distanceInMeters = route.legs[0].distance?.value || 0; // value in meters
      console.log("distance in mtr " + distanceInMeters)
      let distanceInKm = Math.ceil((distanceInMeters / 1000))// Convert to kilometers
      console.log("distance in Km " + distanceInKm)
      RequestBookingService.setDistance(distanceInKm);
      setDistance(distanceInKm);
      setFormValues(prev => ({ ...prev, distance: distanceInKm, }));
      setDuration(route.legs[0].duration?.text || '');
    }
  };

  const handleRideOptionClick = (option: boolean, route: string) => {
    setIsReturnRide(option);
    setFormValues({ ...formValues, returnRide: option })
    if (reqBooking) {
      reqBooking.booking.returnRide = option
    }
    setRoute(route)

  };
  const generateTimeOptions = () => {
    const times = [];
    const formatTime = (hour: number, minute: number) => {
      return ` ${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
    };

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        times.push(formatTime(hour, minute));
      }
    }
    return times;
  };


  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleInputChange(event);
    AppContext.travelDate = event.target.value;
  };

  const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleInputChange(event);
    AppContext.travelTime = event.target.value;
  };
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleInputChange(e);
  };

  const handlePhoneChange = (phoneNumber: string, phoneErr: boolean) => {
    const phoneChangeEvent = {
      target: { name: "phone", value: phoneNumber },
    } as React.ChangeEvent<HTMLInputElement>;

    setIsPhoneError(phoneErr)
    // console.log("phoneChangeEvent  " + JSON.stringify(phoneChangeEvent))
    handleInputChange(phoneChangeEvent);
  };

  return (
    <>
      {(currentStep === 0 || currentStep === 2) && (
        <>
          <CarouselBooking />
          <br />
        </>
      )}

      <div className="border border-2 border-secondary rounded p-3 shadow">
        {currentStep === 0 && (
          <>
            <br />
            <h5 className="text-center text-success">Booking Request</h5>
            <h6>Pune to Mumbai / Mumbai - Pune Ride</h6>
            <hr />

            <form noValidate autoComplete="off">
              <SelectRoute onPress={handleRideOptionClick} />

              <div className="row">
                <div className="col-12">
                  <TextField
                    label="Enter Your Name"
                    fullWidth
                    name="name"
                    value={formValues.name}
                    onChange={handleNameChange}
                    required
                    variant="outlined"
                    sx={{ bgcolor: "white", borderRadius: 1, mt: 3, mb: 0 }}
                  />
                </div>
              </div>

              <CountryCodePicker
                phoneText={formValues.phone}
                onChange={handlePhoneChange}
              />

              <SelectSourceAndDestination
                handleInputChange={handleInputChange}
                selectedRoute={route}
                isReturn={isReturnRide}
              />
              <br />
              <h6 className="text-start">
                Terminal 2 - Chhatrapati Shivaji Maharaj International Airport Mumbai (CSMIA)
              </h6>
              <h6 className="text-start">
                Terminal 1 - Domestic Airport, Mumbai
              </h6>
              <br />
              <div className="row">
                <div className="col-12">
                  <TextField
                    type="date"
                    name="bookingDate"
                    label="Booking Date (dd-mm-yyyy)"
                    fullWidth
                    value={AppContext.travelDate}
                    onChange={handleDateChange}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      min: new Date().toISOString().split("T")[0],
                    }}
                    variant="outlined"
                    required
                    sx={{ bgcolor: "white", borderRadius: 1, }}
                  />
                </div>

                <div className="col-12">
                  <TextField
                    select
                    name="bookingTime"
                    label="Booking Time (24-hour format)"
                    fullWidth
                    value={AppContext.travelTime}
                    onChange={handleTimeChange}
                    variant="outlined"
                    required
                    sx={{ bgcolor: "white", borderRadius: 1, mt: 2, textAlign: "left" }}
                  >
                    {generateTimeOptions().map((time) => (
                      <MenuItem key={time} value={time}>
                        {time}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>

              <br />

              <div className="col-12">
                <Snackbar
                  open={snackbarOpen}
                  autoHideDuration={2000}
                  onClose={handleCloseSnackbar}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  className="snackbarPosition"
                  aria-live="assertive"
                >
                  <Alert onClose={handleCloseSnackbar} severity="error">
                    {snackbarMessage}
                  </Alert>
                </Snackbar>
              </div>

              <div className="d-grid">
                <button
                  type="button"
                  className="btn primary-button w-100"
                  onClick={handleNext}
                >
                  NEXT
                </button>
              </div>
              <br />
            </form>
          </>
        )}

        {currentStep === 1 && (
          <>
            <h5 className="text-center text-success">Booking Request</h5>
            <hr />
            <NewBookingForm2
              formValues={formValues}
              handleInputChange={handleInputChange}
              handleNext={handleNext}
              handleBack={handleBack}
            />
          </>
        )}

        {currentStep === 2 && (
          <NewBookingForm3
            formValues={formValues}
            handleBack={handleBack}
          />
        )}
      </div>
    </>

  );
};

export default NewBookingPage;
